import { noop } from 'lodash';
import React from 'react';

import { DeviceCheckType } from '~/generated/graphql';
import { DeviceCheckContextStateType } from '~/types';

export const deviceCheckContextInitialState: DeviceCheckContextStateType = {
  checkResults: [],
  checksToRun: [],
  currentIndex: 0,
  hasError: undefined,
  isRunning: false,
  percentProgress: 0,
};

export const DeviceCheckContext = React.createContext({
  actions: {
    /* eslint-disable @typescript-eslint/no-unused-vars, lodash/no-extra-args */
    resetContext: async (
      stateToKeep?: Partial<DeviceCheckContextStateType>,
    ): Promise<void> => {
      await Promise.resolve(noop(stateToKeep));
    },
    run: async (args: {
      registrationId?: string;
      shouldExitElectronKioskModeOnDone?: boolean;
      testCenterId: string;
      type: DeviceCheckType;
      registrationDetails: string;
      isBYOD: boolean;
    }): Promise<void> => {
      await Promise.resolve(noop(args));
    },
  },
  state: deviceCheckContextInitialState,
});

export type DeviceCheckContextType = React.ContextType<
  typeof DeviceCheckContext
>;

export default DeviceCheckContext;
